import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute, Router } from "@angular/router";
import { COLUMNS } from "./columns";
import { AuthService } from "src/app/injectable/auth/auth.service";
import { GenericErrorModalService } from "src/app/injectable/generic-error-handling/generic-error-modal.service";
import { MessageService } from "src/app/injectable/message.service";
import { Message } from "src/app/model/message";
import { PaginatorConfig } from "src/app/model/paginatorConfig";
import { DialogGenericErrorResponseComponent } from "src/app/shared/components/dialog/dialog-generic-error-response/dialog-generic-error-response.component";
import { DialogSentMessageComponent } from "src/app/shared/components/dialog/dialog-sent-message/dialog-sent-message.component";
import { DialogComponent } from "../../shared/components/dialog/dialog.component";
import { FailedMessageSendingComponent } from "../failed-message-sending/failed-message-sending.component";
import { App24PAMatPaginator } from "./customPaginatorIntl";
import { NewMessageComponent } from "./new-message/new-message.component";
import { Pageable2 } from "src/app/model/pageable2";
import { Select } from "@ngxs/store";
import { Observable, Subscription } from "rxjs";
import { AppState } from "src/app/app-state";

@Component({
  selector: "app-show-message",
  templateUrl: "./show-message.component.html",
  styleUrls: ["./show-message.component.scss"],
  animations: [
    trigger("detailExpand", [
      state(
        "collapsed",
        style({
          opacity: 0,
          height: "0px",
          minHeight: "0",
          visibility: "hidden",
        })
      ),
      state(
        "expanded",
        style({ opacity: 1, height: "*", visibility: "visible" })
      ),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
})
export class ShowMessageComponent implements OnInit, OnDestroy {
  @Select(AppState.isUserAdmin) isUserAdmin$: Observable<boolean>;

  constructor(
    public messageService: MessageService,
    public dialog: MatDialog,
    private genericErrorModalService: GenericErrorModalService,
    private router: Router,
    private route: ActivatedRoute,
    private _snackBar: MatSnackBar,
    private authService: AuthService
  ) {}

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild("paginator") paginator: MatPaginator;
  @ViewChild("filter", { static: true }) filter: ElementRef;
  @ViewChild("terminateButton") private terminateButton: ElementRef;
  pageable: Pageable2 = new Pageable2();
  messagesForPage = 50;
  messagesTotalLength = 0;
  page = 0;
  counterRefresh = 0;
  totalElements: number;
  message: Message;
  // messages: Message[] = new Array<Message>(); // era 25
  displayedColumns = [
    "validity",
    "senderName",
    "subject",
    "messagesSent",
    "messagesRead",
    "price",
    "startDate",
    "expirationDate",
  ];
  dataSource;
  currentColumnOrder: string = COLUMNS.endDate;
  areas: string;
  data: Date;
  progress = true;
  serverMessage: any = "";
  messageStatus: number;
  expandedElement: any;
  user: any;
  durationInSecondsOfSnackbar = 5;
  mapDisplayed = true;
  mapToLoadIndex: number;
  sub = false;
  emptyList = false;
  loading = false;
  pageSize: number;
  filterValue = "";
  matPaginatorCustom: App24PAMatPaginator;
  paginatorConfig: PaginatorConfig;
  pageEvent: PageEvent;
  subscription: Subscription = new Subscription();
  isUserAdmin: any;

  ngOnInit() {
    this.paginatorConfig = new PaginatorConfig();
    if (sessionStorage.getItem("messageSort") != null) {
      let tmpfilterconfig = JSON.parse(sessionStorage.getItem("messageSort"));
      this.paginatorConfig.setFilterColumn(tmpfilterconfig["active"]);
      this.paginatorConfig.setFilterDirection(tmpfilterconfig["direction"]);
    } else {
      this.paginatorConfig.setFilterColumn("startDate");
      this.paginatorConfig.setFilterDirection("desc");
    }
    this.pageable = {
      pageable: {
        pageNum: this.paginatorConfig.getPageNum(),
        pageSize: this.paginatorConfig.getPageSize(),
      },
      sort: {
        column: this.paginatorConfig.getFilterColumn(),
        direction: this.paginatorConfig.getFilterDirection(),
      },
      filter: {
        columns: ["subject", "content", "sender.name"],
        value: "",
      },
    };

    if (sessionStorage.getItem("latestPageMessaggi") != null) {
      try {
        this.pageable.pageable.pageNum = Number(
          sessionStorage.getItem("latestPageMessaggi")
        );
      } catch (e) {}
    }

    this.dataSource = new MatTableDataSource<Message>();
    this.subscription.add(
      this.isUserAdmin$.subscribe((value) => {
        this.isUserAdmin = value;
        if (
          !(value === undefined) &&
          sessionStorage.getItem("latestFilterValueMessaggi") == null
        )
          this.loadMessages();
      })
    );
    if (sessionStorage.getItem("latestFilterValueMessaggi") != null) {
      this.filterValue = sessionStorage.getItem("latestFilterValueMessaggi");
      this.onFiltering();
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  // applyFilter(filterValue: string) {
  //   this.dataSource.filter = filterValue.trim().toLowerCase();
  //   this.expandedElement = undefined;
  // }

  onPagination(event: PageEvent) {
    this.pageable.pageable = {
      pageNum: event.pageIndex,
      pageSize: event.pageSize,
    };
    sessionStorage.setItem("latestPageMessaggi", event.pageIndex.toString());
    this.loadMessages();
  }

  loadMessages() {
    this.loading = true;
    this.messageService.getMessageList(this.pageable).subscribe(
      (response) => {
        this.loading = false;
        let resp: Message[] = new Array<Message>();
        resp = Array.from(response.list);
        //////////////////////////////////////////////////
        resp.forEach((item) => {
          if (item.messageTypeId == "4") {
          }
        });
        //////////////////////////////////////////////////
        this.totalElements = response.totalElements;
        if (resp.length > 0) {
          this.emptyList = false;
          for (let i = 0; i < resp.length; i++) {
            let validity;
            if (resp[i].messageStatusId === 92) {
              validity = 4;
            } else {
              if (
                new Date(resp[i].startDate).getTime() < new Date().getTime()
              ) {
                if (
                  new Date(resp[i].endDate).getTime() < new Date().getTime()
                ) {
                  validity = 3;
                } else {
                  validity = 2;
                }
              } else {
                validity = 1;
              }
            }
            resp[i].validity = validity;
            let areaString;
            if (!resp[i].messagesRead) {
              resp[i].messagesRead = 0;
            }
            if (!resp[i].messagesSent) {
              resp[i].messagesSent = 0;
            }
            if (resp[i].area != null) {
              for (const ar of resp[i].area) {
                if (areaString == undefined) {
                  areaString = ar.area;
                } else {
                  areaString += ", " + ar.area;
                }
              }
              // Per Aree
              if (resp[i].messageTypeId == "1") {
                resp[i].area = areaString;
              }
              // Per Raggio
              if (resp[i].messageTypeId == "4") {
              }
              // Per Lista di Distribuzione
              if (resp[i].messageTypeId == "7") {
              }
              // --> Check sul messageTypeId
            } else {
              resp[i].area = [
                {
                  area: "—",
                  id: 0,
                  geomArea: null,
                  centroidLat: 0,
                  centroidLon: 0,
                },
              ];
            }
          }
        } else {
          this.emptyList = true;
        }
        this.dataSource.data = response.list;
      },
      (err) => {
        this.loading = false;
        this.genericErrorModalService.open(
          "Errore nel caricamento della lista messaggi",
          err
        );
      }
    );
  }

  onFilterClear() {
    this.filterValue = "";
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(DialogComponent, {
      width: "500px",
      data: { message: this.serverMessage.message },
    });
    dialogRef.afterClosed().subscribe((result) => {});
  }

  openErrorDialogSentMessage(msg: string, error: string) {
    const dialogRef = this.dialog.open(DialogGenericErrorResponseComponent, {
      width: "500px",
      height: "220px",
      data: {
        message: msg,
        errorCode: error,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {});
  }

  newMessageDialog(): void {
    this.loading = true;
    this.messageService.getSenderList().subscribe(
      (senders) => {
        this.loading = false;
        if (senders.length == 0) {
          this.dialog.open(NoSendersFoundDialog);
          return;
        }
        const dialogRef = this.dialog.open(NewMessageComponent, {
          panelClass: "custom-dialog-container",
          width: "700px",
          height: "80vh",
          data: { senders },
          disableClose: true,
        });
        dialogRef.afterClosed().subscribe((result) => {
          if (result == "MES01") {
            // this.openSuccessDialogSentMessage('Messaggio inviato.', result);
            this.openSnackBar("Messaggio inviato con successo.", "Chiudi");
            this.router
              .navigateByUrl("/refreshComponent", { skipLocationChange: true })
              .then(() => {
                this.router.navigate(["/messages"]);
              });
          } else if (result == "ERR") {
            this.genericErrorModalService.open(
              "Errore nell'invio messaggio",
              "ERR27"
            );
          } else if (result === undefined) {
          }
        });
      },
      (error) => {
        this.loading = false;
        console.error(error);
        this.genericErrorModalService.open(
          "Errore nel caricamento della lista dei mittenti",
          error
        );
      }
    );
  }

  openSuccessDialogSentMessage(message: string, result: string): void {
    const dialogRef = this.dialog.open(DialogSentMessageComponent, {
      width: "500px",
      height: "220px",
      data: {
        message,
        result,
      },
    });
  }

  openFailedSnackBar() {
    this._snackBar.openFromComponent(FailedMessageSendingComponent, {
      duration: this.durationInSecondsOfSnackbar * 1000,
    });
  }

  onSortChange(sort) {
    sessionStorage.setItem("messageSort", JSON.stringify(sort));

    switch (sort.active) {
      case "senderName": {
        this.pageable.pageable.pageNum = 0;
        this.pageable.sort.column = "sender";
        this.pageable.sort.direction = sort.direction.toUpperCase();
        this.loadMessages();
        break;
      }
      case "subject": {
        this.pageable.pageable.pageNum = 0;
        this.pageable.sort.column = "subject";
        this.pageable.sort.direction = sort.direction.toUpperCase();
        this.loadMessages();
        break;
      }
      case "startDate": {
        this.pageable.pageable.pageNum = 0;
        this.pageable.sort.column = "startDate";
        this.pageable.sort.direction = sort.direction.toUpperCase();
        this.loadMessages();
        break;
      }
      case "messagesRead": {
        this.pageable.pageable.pageNum = 0;
        this.pageable.sort.column = "messagesRead";
        this.pageable.sort.direction = sort.direction.toUpperCase();
        this.loadMessages();
        break;
      }
      case "messagesSent": {
        this.pageable.pageable.pageNum = 0;
        this.pageable.sort.column = "messagesSent";
        this.pageable.sort.direction = sort.direction.toUpperCase();
        this.loadMessages();
        break;
      }
      case "expirationDate": {
        this.pageable.pageable.pageNum = 0;
        this.pageable.sort.column = "endDate";
        this.pageable.sort.direction = sort.direction.toUpperCase();
        sort.active = "endDate";
        sessionStorage.setItem("messageSort", JSON.stringify(sort));
        this.loadMessages();
        break;
      }
      default: {
        break;
      }
    }
  }

  onMessageDetail(message) {
    this.router.navigate([message.id], { relativeTo: this.route });
  }

  onFiltering() {
    this.pageable.filter.value = this.filterValue;
    try {
      this.paginator.firstPage();
    } catch (e) {}
    sessionStorage.setItem("latestFilterValueMessaggi", this.filterValue);
    this.loadMessages();
  }

  onSearchKeydown(event) {
    if (event.key === "Enter") {
      if (this.filterValue.length == 0 || this.filterValue.length > 3) {
        this.paginator.firstPage();
        this.pageable.filter.value = this.filterValue;
        sessionStorage.setItem("latestFilterValueMessaggi", this.filterValue);
        this.loadMessages();
      }
    }
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 3500,
      panelClass: "custom-snackbar",
    });
  }
}

@Component({
  selector: "no-senders-found-dialog",
  templateUrl: "./no-senders-found-dialog.html",
})
export class NoSendersFoundDialog {}
